import React, { Component } from "react";
import html2canvas from "html2canvas";
import { QRCode } from "react-qrcode-logo";
import Fbutton from "../../components/Finputs/FButton/Fbutton";

export default class PersonalQrScreen extends Component {
  ref = React.createRef();

  handleClickTakeScreenShot = () => {
    const { cropPositionTop, cropPositionLeft, cropWidth, cropHeigth } = {
      cropPositionTop: 0,
      cropPositionLeft: 0,
      cropWidth: 1400,
      cropHeigth: 1300,
    };

    html2canvas(this.ref.current).then(canvas => {
      let croppedCanvas = document.createElement("canvas");
      let croppedCanvasContext = croppedCanvas.getContext("2d");

      croppedCanvas.width = cropWidth;
      croppedCanvas.height = cropHeigth;

      croppedCanvasContext.drawImage(canvas, cropPositionLeft, cropPositionTop);

      const a = document.createElement("a");
      a.href = croppedCanvas.toDataURL();
      a.download = "qr.png";
      a.click();
    });
  };

  render() {
    const { children } = this.props;

    return (
      <div className="text-center">
      <div
          id="#screenshot"
          // style={{ position: "relative", left: "-1000px" }}
          ref={this.ref}
      >
          <div className="text-Secondary text-2xl font-bold">Tu QR</div>
          <div className="text-md">Comparte tu código QR con tus amigos para que te compartan un Fiado.</div>
          

          <div className="flex justify-center p-4 pb-10">
              <QRCode
                  value={JSON.stringify({
                      type: "static",
                      phoneNumber: JSON.parse(localStorage.getItem("tokenDecoded")).phone_number,
                      directoryId: JSON.parse(localStorage.getItem("tokenDecoded")).directoryId
                    })}
                    size={270}
                />
          </div>
      </div>
      
      <Fbutton
        value="Descargar"
        onClick={this.handleClickTakeScreenShot}
      />
      
</div>
    );
  }
}

  